import React, {useEffect, useState} from 'react';
import {Link, NavLink, withRouter} from 'react-router-dom'
import {Collapse, DropdownMenu, DropdownToggle, NavbarToggler, NavItem, Dropdown, Navbar, Nav, NavbarBrand} from 'reactstrap';
import {buildTree} from "../../helpers";
import {PriceAndBidding} from "../../modules/FullScreenPhotos";
import {debounce} from "lodash";

const HorizontalMenu = ({toggleMenu, sitePrefix, menuCollapsed, logo, currentPath, pages, isMobile,
                            purchasePrice,
                            bidding,
                            siteID,
                            online_bidding,
                            country,
                            biddingForms,
                            terms,
                            renderModal,
                            customFormText,
                            customBiddingFormText,
                            street,
                            number,
                            addition,
                            city,
                            theme,
                            status,
                            icons
                        }) => {

    const [state, setState] = useState({
        init: 0,
        pagesTree: []
    })

    useEffect(() => {
        setState({
            ...state,
            pagesTree: buildTree(pages)
        })
    }, [pages])

    useEffect(() => {
        if (window.innerWidth < 991) {
            toggleMenu('close')
        }
    }, [currentPath])

    return (
        <>
            <Navbar color="faded" light expand="xl" className="bg-light text-uppercase shadow-lg sticky-top" style={{zIndex: 1, height: 60 + 'px'}}>
                <div className="container-fluid">
                    <div className="logo-container">
                        <NavbarBrand className="logo-mobile p-2" href="/"><img src={logo}/></NavbarBrand>
                    </div>

                    <NavbarToggler onClick={toggleMenu}/>

                    <Collapse isOpen={menuCollapsed} navbar>
                        <Nav navbar className="mr-auto p-2 pl-3 pl-sm-1 mr-0 mr-sm-5 mt-3 mt-sm-0">
                            {state.pagesTree.map((page, index) =>
                                <ConstructMenuItem key={page.id} page={page} sitePrefix={sitePrefix} item_key={index}
                                                   currentPath={currentPath}
                                                   isMobile={isMobile}/>
                            )}
                        </Nav>
                    </Collapse>
                </div>
            </Navbar>
            {theme === 'era' &&
            <div id="info-block" className="mobile-address-container" style={{zIndex: '1'}}>
                <MenuFooterIcons icons={icons}/>
                <div className="custom_footer_img"></div>
                <div className="info-block-text">
                    <h3>{street} {number}{addition}, {city}</h3>
                    <PriceAndBidding
                        price={purchasePrice}
                        status={status}
                        bidding={online_bidding}
                        siteID={siteID}
                        online_bidding={online_bidding}
                        country={country}
                        biddingForms={biddingForms}
                        sitePrefix={sitePrefix}
                        terms={terms}
                        renderModal={renderModal}
                        customFormText={customFormText}
                        customBiddingFormText={customBiddingFormText}
                    />
                </div>
            </div>
            }
        </>

    )

}

export default withRouter(HorizontalMenu);

const ConstructMenuItem = ({page, sitePrefix, item_key, isMobile, currentPath}) => {
    if ((typeof page.children === 'undefined' || page.children.length == 0)) {

        let activeClass = checkChildActive(page, currentPath);

        return (
            <LinkBlock {...page} key={page.id} activeClass={activeClass} sitePrefix={sitePrefix}/>
        )
    } else {

        let activeClass = checkChildActive(page, currentPath);

        return (
            <HorizontalDropdownMenu item_key={item_key} isMobile={isMobile} key={page.id} page={page}
                                    sitePrefix={sitePrefix} activeClass={activeClass}/>
        )
    }
}


const LinkBlock = (props) => {
    const {itemKey, title, slug, sitePrefix, subtitle, type, external_url, background_image, activeClass} = props;

    if (type === 'externalLink') {
        return (
            <>
                <NavItem key={itemKey} className={`text-nowrap${activeClass && ' active'}`}>
                    <NavLink className="nav-link primary-border-color"
                             to={{pathname: external_url}} target="_blank"
                             activeClassName="active color-primary">
                        {!!background_image && <img src={background_image} style={{width: '100%'}}/>}
                        {!background_image && title}
                        {/*<span className="d-none d-md-block small">{subtitle}</span>*/}
                    </NavLink>
                </NavItem>
                {/*<a href={external_url} key={itemKey} className="menu-item d-block d-md-none">*/}

                {/*    {!!background_image && <img src={background_image} style={{width: '100%'}}/>}*/}
                {/*    {!background_image && title}*/}

                {/*    /!*<span className="d-none d-md-block small">{subtitle}</span>*!/*/}
                {/*</a>*/}
                {/*<a href={external_url} key={itemKey} className="menu-item d-none d-md-block" target="_blank">*/}

                {/*    {!!background_image && <img src={background_image} style={{width: '100%'}}/>}*/}
                {/*    {!background_image && title}*/}

                {/*    /!*<span className="d-none d-md-block small">{subtitle}</span>*!/*/}
                {/*</a>*/}
            </>
        )
    }

    if (type === 'Dropdown' || type === 'documentatieLijst') {

        return (
            <NavItem key={itemKey} className={`text-nowrap${activeClass && ' active'}`}>
                <NavLink className="nav-link primary-border-color"
                         to={sitePrefix + slug}
                         activeClassName="active color-primary"
                         path={sitePrefix + slug}>
                    {title}
                    {/*<span className="d-none d-md-block small">{subtitle}</span>*/}
                </NavLink>
            </NavItem>
        )
    }

    return (
        <NavItem key={itemKey} className={`text-nowrap${activeClass && ' active'}`}>
            <NavLink className="nav-link primary-border-color"
                     to={sitePrefix + slug}
                     activeClassName="active color-primary"
                     path={sitePrefix + slug}>
                {title}
                {/*<span className="d-none d-md-block small">{subtitle}</span>*/}
            </NavLink>
        </NavItem>
    )

}

const HorizontalDropdownMenu = (props) => {

    const {page, sitePrefix, activeClass, item_key, isMobile, currentPath} = props;
    const [showDropdown, setShowDropdown] = useState(false);
    const handleMouseLeave = debounce(() => setShowDropdown(false), 200);

    const handleMouseEnter = () => {
        setShowDropdown(true)
        handleMouseLeave.cancel()
    }

    return (
        <Dropdown isOpen={showDropdown} active={activeClass === 'active'} setActiveFromChild key={item_key} nav inNavbar>
            <DropdownToggle nav caret className={`primary-border-color${activeClass && ' active'}`}
                            onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                {page.title}
            </DropdownToggle>
            <DropdownMenu tag={'ul'} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                {page.children.map((el) => <ConstructMenuItem key={el.id} page={el} sitePrefix={sitePrefix}
                                                              item_key={item_key}
                                                              currentPath={currentPath}
                                                              isMobile={isMobile}/>)}
            </DropdownMenu>
        </Dropdown>
    )

}

const checkChildActive = (page, currentPath) => {
    let data = '';
    if ((typeof page.children === 'undefined' || page.children.length == 0)) {
        if (page.slug === currentPath) {
            return true;
        }
    } else {
        let results = page.children.map((page) => checkChildActive(page, currentPath));
        if (results.indexOf(true) >= 0 || results.indexOf('active') >= 0) {
            data = 'active';
        }
    }
    return data;
}

const MenuFooterIcons = (props) => {
    const {icons} = props;
    if(icons.length > 0) {
        return (<div className="social-media-icons-light-theme">
            <div className='text-center'>
                {icons.map(function (icon, index) {
                    let className = icon[0] + " social_icon fa-3x mr-2";
                    return (
                        <a href={icon[1]} target="_blank" key={index}>
                            <i className={className}></i>
                        </a>
                    )
                })}
            </div>
        </div>);
    }
    return null;
};
